import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-patient-stats-card',
  templateUrl: './patient-stats-card.component.html',
  styleUrls: ['./patient-stats-card.component.css']
})
export class PatientStatsCardComponent implements OnInit {

  constructor() { }

  @Input() stat;
  @Input() unit;
  @Input() icon;

  ngOnInit() {
  }

}
